const trimTrailingSlash = (value) => String(value || "").trim().replace(/\/+$/, "");

const joinUrl = (baseUrl, path) => {
  const normalizedPath = String(path || "");
  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath;
  }
  const base = trimTrailingSlash(baseUrl);
  return base ? `${base}${normalizedPath.startsWith("/") ? "" : "/"}${normalizedPath}` : normalizedPath;
};

export function getKyrosApiBaseUrl() {
  return trimTrailingSlash(process.env.REACT_APP_KYROS_API_BASE_URL);
}

export function getZombieCrushersApiBaseUrl() {
  return trimTrailingSlash(process.env.REACT_APP_API_BASE_URL);
}

export function resolveKyrosApiUrl(path) {
  return joinUrl(getKyrosApiBaseUrl(), path);
}

export function resolveZombieCrushersApiUrl(path) {
  return joinUrl(getZombieCrushersApiBaseUrl(), path);
}
